import Tippy from '@tippyjs/react';
import React, { useState } from 'react';
import 'tippy.js/dist/tippy.css';
import './Tooltip.css';

type TooltipProps = {
  title: string;
  content: React.ReactNode;
  top?: string;
  left?: string;
  width?: string;
  interactive?: boolean;
};

export type TooltipContextValue = {
  setTooltipVisibility: (visible: boolean) => void;
};

export const TooltipContext = React.createContext<TooltipContextValue>({
  setTooltipVisibility: () => {},
});

const Tooltip: React.FC<TooltipProps> = ({
  title,
  content,
  children,
  top,
  left,
  width,
  interactive = true,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  const tippyContent = (
    <>
      <p className="font-size-4 medium mt0 mb3">{title}</p>
      {content}
      <button
        className="cursor-pointer pos-a pr0 pl0 close-button b-width-0"
        type="button"
        onClick={() => setVisible(false)}
      >
        <svg
          height="16px"
          width="16px"
          viewBox="0 0 16 16"
          className="fill-gray-7"
        >
          <path
            d="M11.202 4.126L8 7.326 4.8 4.128c-.19-.175-.48-.17-.662.011l-.034.04c-.15.186-.14.46.034.634L7.326 8l-3.198 3.199c-.175.19-.17.48.011.662.181.18.472.186.66.013L8 8.674l3.199 3.198c.19.175.48.17.662-.011l.034-.04c.15-.186.14-.46-.034-.634L8.673 8 11.872 4.8c.175-.19.17-.48-.011-.662-.181-.18-.472-.186-.66-.013z"
            transform="translate(-466 -132) translate(162 116) translate(304 16)"
          />
        </svg>
      </button>
    </>
  );

  return (
    <TooltipContext.Provider
      value={{
        setTooltipVisibility: setVisible,
      }}
    >
      <Tippy
        arrow={false}
        content={tippyContent}
        placement="bottom"
        interactive={interactive}
        visible={visible}
        css={{
          backgroundColor: '#fff',
          top: top || 'auto',
          left: left || 'auto',
          width: width || 'auto',
        }}
      >
        <div>{children}</div>
      </Tippy>
    </TooltipContext.Provider>
  );
};

export default Tooltip;
